const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="lucide lucide-circle-check-icon lucide-circle-check"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="1.818"
      d="M12 0C5.385 0 0 5.385 0 12s5.385 12 12 12 12-5.385 12-12S18.615 0 12 0m0 2.18A9.803 9.803 0 0 1 21.82 12 9.803 9.803 0 0 1 12 21.82 9.803 9.803 0 0 1 2.18 12 9.803 9.803 0 0 1 12 2.18"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="1.818"
      d="M15.273 8.727a1.1 1.1 0 0 0-.771.32L10.91 12.64l-1.412-1.41a1.09 1.09 0 0 0-1.543 0 1.09 1.09 0 0 0 0 1.542l2.182 2.182a1.09 1.09 0 0 0 1.543 0l4.365-4.363a1.09 1.09 0 0 0 0-1.543 1.1 1.1 0 0 0-.772-.32"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;
